import TagType from '../constants/TagType';
import BaseModel from './BaseModel';
import { OutletId } from './Outlet';

export interface TagId {__tagId: number}

export default class Tag<ID = TagId> extends BaseModel<ID> {
  outletId: OutletId | null = null;
  colorHex: string | null = null;
  description: string | null = null;
  type!: TagType;
  isPause = false;
  isActive = false;

  equals(that: Tag): boolean {
    return this.id === that.id && this.outletId === that.outletId;
  }

  getAbbreviation(): string {
    return this.description?.slice(0, 3) ?? '';
  }
}
